// Read more about this way of fetching data
// https://redux.js.org/advanced/async-actions#actions-js-with-fetch

import {loadUsersRequest, loadUsersSuccess, deleteUsersRequest} from './actionCreators';
import fetch from 'cross-fetch';
import ApiService from '../services/api';
import { showSnackbar } from "../actions/snackbarActions";

export function loadUsers(state) {
  return (dispatch, getState) => {
    let state = getState();
    return dispatch(getUsers(state))
  }
}

function getUsers(state) {
  let token = state.oidc.user.access_token;

  return dispatch => {
    dispatch(loadUsersRequest())
    return fetch(process.env.API_URL + '/api/Users', {
      headers: {
        'Authorization': 'Bearer ' + token
      }})
      .then(response => response.json())
      .then(json => dispatch(loadUsersSuccess(json)))
  }
}

export const createNew = (content) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const token = state.oidc.user.access_token;
      let apiService = new ApiService(token);
      const postFix = `users`;
      const newUser = await apiService.createNew(postFix, content);
      dispatch({
        type: 'ADD_USER_REQUEST',
        data: newUser
      })
    }
    catch (err) {
      throw Error(err);
    }
  }
}

export const editUser = (content) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const token = state.oidc.user.access_token;
      let apiService = new ApiService(token);
      const editedUser = await apiService.edit("users", content);
      dispatch({
        type: "USERS_EDIT_USER",
        data: editedUser
      })
    }
    catch (err) {
      throw Error(err);
    }
  }
}

export const deleteUser = (content) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const token = state.oidc.user.access_token;
      dispatch(deleteUsersRequest(true));
      let apiService = new ApiService(token);
      const deletedUserId = await apiService.delete("users", content);
      await dispatch({
        type: "USERS_DELETE_USER",
        data: deletedUserId
      });
      dispatch(showSnackbar("User deleted"))
      dispatch(deleteUsersRequest(false));
    }
    catch (err) {
      dispatch(showSnackbar("Error: User delete failed"));
      dispatch(deleteUsersRequest(false));
      //throw Error(err);
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/userActions.js